import React from 'react';
import { AgentConversations } from '@/components/agent-conversations/AgentConversations';

export default function AgentConversationsPage() {
  return (
    <div className="h-[calc(100vh-4rem)]">
      <AgentConversations />
    </div>
  );
}